// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-drawer__wrapper[data-v-07588add] {\n  top: 40px !important;\n}", ""]);
// Exports
module.exports = exports;
